import { render } from "./TheLandingPage.vue?vue&type=template&id=253776f1&scoped=true&ts=true"
import script from "./TheLandingPage.vue?vue&type=script&lang=ts"
export * from "./TheLandingPage.vue?vue&type=script&lang=ts"

import "./TheLandingPage.vue?vue&type=style&index=0&id=253776f1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-253776f1"]])

export default __exports__